module.exports = __webpack_public_path__ + "static/img/hkj5.6acb437.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/hkj5.jpg
// module id = DkA2
// module chunks = 0